import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import useVisibleCallList from '@modules/SoftPhoneModule/useVisibleCallList';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';
import { PipCallBar } from './PipCallBar';

export function PipCallBarManager() {
  const { callAttributes } = usePhoneState();
  const visibleCallList = useVisibleCallList();
  const { selectedTaskId } = useInboxState();

  const allCallsHeld = visibleCallList.every((call) => call.held);

  return (
    <>
      {visibleCallList.map((call) => {
        const attributes = {
          ...callAttributes[call.callId],
          queueIds: callAttributes[call.callId]?.queueIds
            ? [...callAttributes[call.callId].queueIds]
            : [],
          traits: callAttributes[call.callId]?.traits
            ? [...callAttributes[call.callId].traits]
            : [],
        };

        const showSelectedCallBar =
          allCallsHeld &&
          !!selectedTaskId &&
          selectedTaskId === attributes.pcsConversationSid;

        return (
          <PipCallBar
            key={call.callId}
            callState={call}
            show={!call.held || showSelectedCallBar}
          />
        );
      })}
    </>
  );
}
